import { FC, SVGAttributes } from "react";

const CloseSmall: FC<SVGAttributes<SVGSVGElement>> = ({
  width = "12px",
  height = "12px",
  fill = "#999",
  ...restProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    {...restProps}
  >
    <g fill="none" fillRule="evenodd" strokeLinecap="round">
      <g stroke={fill} strokeWidth="2">
        <path
          d="M0 0l10 10m0-10L0 10"
          transform="translate(-376 -124) translate(32 106) translate(326) translate(18 18) translate(1 1)"
        />
      </g>
    </g>
  </svg>
);

export { CloseSmall };
